<template>
  <BModal :model-value="modalConfirm" centered @update:modelValue="updateModal"> 
    <template #header>
        <h5 class="">{{ title}}</h5>
        <BButton
          variant="link"
          class="close"
          @click="updateModal(false)"
        >
          <i class="ion ion-android-close"></i>
        </BButton>
    </template>
    <slot name="text"></slot>
    <slot name="body"></slot>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton tton variant="primary" class="mr-2">Yes</BButton>
            <BButton variant="danger" @click="updateModal(false)">No</BButton>
        </div>
    </template>
  </BModal>
  
</template>

<script>

import { BModal, BButton } from "bootstrap-vue-next";

export default {
    components: {
        BModal, 
        BButton,
    },
    props: {
        title: String,
        modalConfirm: Boolean,
    },
    setup(props, {emit}){
        const updateModal = (value) => {
            emit("update:modalConfirm", value)
        }
        return{
            updateModal
        }
    }
}
</script>

<style>

</style>